import Api from "../../config/ApiConfig";
import { IAccessControl, IDataSourcePostReq, IConnectionPostReq, ISteward, IDataSourcePutReq, ISearchParam } from "./types";
import * as functions from '../../components/shared/functions';

const apiUrls = {
    getAccessControls: "api/v1/adgroups",
    postConnection: "api/v1/connection/test",
    getUsers: "api/v1/users",
    searchDataSources: "api/v1/searches/sources",
    getDataSources: "api/v1/sources",
}

export const getDataSources = (params : ISearchParam) =>
    Api.get(`${apiUrls.searchDataSources}?skip=${params.skip}&top=${params.top}&count=${params.count}&orderby=${params.orderby}&queryType=full&search=${params.search}` +
        functions.getParam(params.layerType, "layerType") + functions.getParam(params.accessControl, "accessControl") + functions.getParam(params.owner, "owner")
        + functions.getParam(params.dataStewards, "dataStewards")  + functions.getParam(params.spokeName, "spokeName")) 
        .then((response) => { return response })
        .catch((error) => { return error.response });   

export const getAccessControls = () =>
    Api.get<IAccessControl[]>(apiUrls.getAccessControls);

export const postDataSource = (payload : IDataSourcePostReq) => 
    Api.post(apiUrls.getDataSources, payload)
        .then((response) => { return response })
        .catch((error) => {return error.response });

    
export const getSourceDetails = (param: number) => 
    Api.get(apiUrls.getDataSources + `/${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });
    
export const deleteSource = (param: number) => 
    Api.delete(apiUrls.getDataSources + `/${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });
        
export const putDataSource = (param: number, payload : IDataSourcePutReq) => 
    Api.put(apiUrls.getDataSources + `/${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });
            
        
export const postConnection = (payload : IConnectionPostReq) => 
    Api.post(apiUrls.postConnection, payload)
        .then((response) => { return response })
        .catch((error) => {return error.response });

export const getStewards = (adGroup: string) =>
    Api.get<ISteward[]>(apiUrls.getUsers + "?adgroup=" + adGroup);
      
      
      